import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  xlsx: any;

  async loadXLSX(): Promise<any> {
    if (!this.xlsx) {
      this.xlsx = await import('xlsx');
    }
    return this.xlsx;
  }

  async exportToExcel(data: any[], fileName: string): Promise<void> {
    try {
      const XLSX = await this.loadXLSX();

      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, `${fileName}.xlsx`);

    } catch (error) {
      console.error('Ошибка при загрузке библиотеки xlsx или экспорте:', error);
    }
  }
}
